/**
 * ? @description : Delete Teacher Profile Modal
 */

// Dependencies
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";

// Axios Component
import Axios from "../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../redux/features/appSlice";

function DeleteModal(props) {
  // * Redux
  const dispatch = useDispatch();

  // ! Teacher Id
  let teacherId = props.tabledata[0];

  // ? API Call : Delete Method : Delete Teacher
  async function deleteProfile() {
    try {
      const options = {
        method: "delete",
        url: `teacher/${teacherId}`,
        auth: true,
        data: null,
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      if (response.status === 200) {
        props.onHide();
        // window.location.reload();
        dispatch(
          showSnackbar({
            message: response.data.message,
            severity: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: "Error occurred while posting comments.",
          severity: "error",
        })
      );
    }
  }

  return (
    props.tabledata && (
      <Modal {...props} size="xl" centered aria-labelledby="delete-teacher">
        <Modal.Header closeButton>
          <Modal.Title id="delete-teacher">
            <h5>Confirmation</h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h6>Are you sure you want to delete this teacher profile&nbsp;?</h6>

          <p
            style={{
              color: "gray",
              fontSize: "12px",
            }}
          >
            <strong style={{ color: "red" }}>Note&nbsp;:&nbsp;</strong>
            Please check mapped status of this profile before deleting it.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button type="button" variant="light" onClick={props.onHide}>
            CANCEL
          </Button>
          <Button type="submit" variant="danger" onClick={deleteProfile}>
            DELETE
          </Button>
        </Modal.Footer>
      </Modal>
    )
  );
}

export default DeleteModal;
